import {useEffect, useState} from "react";
import {useConfig} from "../../hooks/useConfig";

export default function LicensesPage() {
    const [licenseText, setLicenseText] = useState("");

    let config = useConfig();

    useEffect(() => {
        const url = `${config.s3.public_access_url}/license/license.txt`;
        const requestOptions = {method: "GET"};
        fetch(url, requestOptions).then((res) => res.text())
            .then((data) => setLicenseText(data))
            .catch((err) => console.error("Failed to load license:", err));
    }, []);

    return (
        <div
            style={{
                whiteSpace: "pre-wrap",
                fontFamily: "monospace",
                padding: 20,
                fontSize: 15
            }}
        >{licenseText}</div>
    );
}